import gql from 'graphql-tag';

const GET_DEFAULT_POLICY_SET_MAPPING = gql`
  query getDefaultPolicySetMapping($module: String!) {
    getDefaultPolicySetMapping(module: $module) {
      policySet {
        policySetId
        name
        assetClass {
          classId
          supportedModules
        }
      }
      policyCategory {
        policyCategoryId
        name
        assetClass {
          classId
          name
          iconClass
        }
        custom
      }
    }
  }
`;

const GET_POLICY_SET_MAPPING = gql`
  query getPolicySetMapping($clientId: ID, $module: String, $classId: ID) {
    getPolicySetMapping(
      clientId: $clientId
      module: $module
      classId: $classId
    ) {
      policySet {
        policySetId
        name
        assetClass {
          classId
          supportedModules
        }
      }
      policyCategory {
        policyCategoryId
        name
        assetClass {
          classId
          name
          iconClass
        }
        custom
      }
    }
  }
`;

const GET_POLICY_SETS = gql`
  query getPolicySets($classId: ID!) {
    getPolicySets(classId: $classId) {
      policySetId
      name
      parentPolicySet {
        policySetId
        name
      }
      assetClass {
        classId
        iconClass
        name
      }
      lastUpdatedTime
      lastUpdatedBy {
        userId
        name
      }
      createdTime
      createdBy {
        userId
        name
      }
    }
  }
`;

const UPDATE_CLIENT_POLICY = gql`
  mutation($input: ClientInput) {
    updateClient(input: $input) {
      accountId
      name
    }
  }
`;

const UPDATE_TRANSITION = gql`
  mutation($toggle: Boolean) {
    toggleAdvHierarchyTransition(toggle: $toggle)
  }
`;

const GET_POLICY_CATEGORY = gql`
  query($module: [String], $custom: Boolean) {
    getPolicyCategories(module: $module, custom: $custom) {
      policyCategoryId
      name
      custom
      assetClass {
        classId
        name
        iconClass
      }
      createdTime
      createdBy {
        userId
        name
      }
      lastUpdatedTime
      lastUpdatedBy {
        userId
        name
      }
    }
  }
`;

const GET_UNMAPPED_POLICY_CATEGORY_FOR_POLICYSET = gql`
  query($clientId: ID, $modules: [String], $classId: ID, $custom: Boolean) {
    getUnmappedPolicyCategoriesForClient(
      modules: $modules
      custom: $custom
      clientId: $clientId
      classId: $classId
    ) {
      policyCategoryId
      name
      custom
      assetClass {
        classId
        name
        iconClass
      }
      createdTime
      createdBy {
        userId
        name
      }
      lastUpdatedTime
      lastUpdatedBy {
        userId
        name
      }
    }
  }
`;

const GET_MAPPED_POLICY_CATEGORY_FOR_POLICYSET = gql`
  query($policySetId: ID) {
    getMappedPolicyCategoriesForPolicySet(policySetId: $policySetId) {
      client {
        accountId
        name
      }
      policyCategory {
        policyCategoryId
        name
      }
      policySet {
        policySetId
        name
      }
    }
  }
`;

const BULK_UPDATE_POLICY_CATEGORY_POLICYSET_MAPPINGS = gql`
  mutation($input: [PolicyCategoryPolicySetMappingInput]) {
    bulkUpdatePolicyCategoryPolicySetMappings(input: $input) {
      client {
        accountId
        name
      }
      policyCategory {
        policyCategoryId
        name
      }
      policySet {
        policySetId
        name
      }
    }
  }
`;

const DELETE_POLICY_SET = gql`
  mutation($policySetId: ID!) {
    deletePolicySet(policySetId: $policySetId)
  }
`;

export {
  GET_DEFAULT_POLICY_SET_MAPPING,
  GET_POLICY_SET_MAPPING,
  GET_POLICY_SETS,
  UPDATE_CLIENT_POLICY,
  GET_POLICY_CATEGORY,
  UPDATE_TRANSITION,
  GET_MAPPED_POLICY_CATEGORY_FOR_POLICYSET,
  GET_UNMAPPED_POLICY_CATEGORY_FOR_POLICYSET,
  BULK_UPDATE_POLICY_CATEGORY_POLICYSET_MAPPINGS,
  DELETE_POLICY_SET
};
